import { Module } from 'vuex'
import getters from '@/store/editor/getters'
import actions from '@/store/editor/actions'
import mutations from '@/store/editor/mutations'
import defaultStencils from '@/store/stencils'
import { EditorEntry, FieldSet, EditorState, StencilSet } from '@/store/editor/types'
import { RootState } from '@/store/types'

const entry: EditorEntry = {
    id: undefined,
    schema: 'website',
    existing: false,
    locked: false,
    favourite: false,
    icon: 'bolt',
    permission: 'creator',
    topLevel: false,
    fields: {} as FieldSet,
    vault: undefined,
    tags: [],
    vaultError: undefined,
    model: undefined
}

const state: EditorState = {
    entry,
    tagOptions: [],
    stencils: defaultStencils as StencilSet,
    blank: true
}

const editor: Module<EditorState, RootState> = {
    state,
    getters,
    actions,
    mutations
}

export default editor
